// extracted by mini-css-extract-plugin
module.exports = {"profileSelect":"_36y3w","noSkillsWrapper":"_8gmpK"};